/* eslint-disable no-nested-ternary */
import styled from "@emotion/styled"
import Checkbox from "@mui/material/Checkbox"
import ListItemText from "@mui/material/ListItemText"
import MenuItem from "@mui/material/MenuItem"
import Select from "@mui/material/Select"
import { Dispatch, SetStateAction, useState } from "react"
import {
  FilterArrowIcon,
  FilterCheckbox,
  useIsDesktop,
  useIsLargeDesktop,
} from "ui"
import { OtherState } from "./JobsSearch"

const StyledMenuItem = styled(MenuItem) <{ selected: boolean }>`
  padding: 0;
  padding-right: 6px;
  margin: 0;
  color: #153e69;

  span {
    font-weight: ${(props) => (props.selected ? 500 : 400)};
    font-size: 16px;
    line-height: 24px;
    ${(props) => props.theme.breakpoints.up("md")} {
      font-size: 12px;
      line-height: 16px;
    }
    ${(props) => props.theme.breakpoints.up("lg")} {
      font-size: 16px;
      line-height: 24px;
    }
  }

  border-bottom: 1px dashed black;
  background: ${(props) => (props.selected ? "#153E694D" : "transparent")};
`

type Props = {
  categoryState: OtherState
  setCategoryState: Dispatch<SetStateAction<OtherState>>
  titleHeader: string
  label: string
}

const StyledSelect = styled(Select)`
  width: 100%;
  ${(props) => props.theme.breakpoints.up("md")} {
    width: 165px;
  }

  color: #153e69;
  ${(props) => props.theme.breakpoints.up("lg")} {
    width: 248px;
  }
  fieldset {
    border: none;
  }

  /* Add focus-visible rule */
 div[role="button"]:focus-visible {
    border: 1px solid black !important; /* Only when keyboard-focused */
  }

  div[role="button"] {
    display: flex;
    align-items: center;
    height: 24px;
    padding: 0;
    font-size: 16px;
    line-height: 24px;
    ${(props) => props.theme.breakpoints.up("md")} {
      font-size: 12px;
      line-height: 16px;
    }
    ${(props) => props.theme.breakpoints.up("lg")} {
      font-size: 16px;
      line-height: 24px;
    }
  }
  ${(props) => props.theme.breakpoints.up("md")} {
    > div {
      padding: 0px;
    }
  }
`
export default function OtherDropBox({
  categoryState,
  setCategoryState,
  titleHeader,
  label
}: Props) {
  const [open, setOpen] = useState(false)
  const isDesktop = useIsDesktop()
  const isLargeDesktop = useIsLargeDesktop()
  const width = () => {
    if (isLargeDesktop) {
      return 289
    } else if (isDesktop) {
      return 192
    } else {
      return 142
    }
  }
  const handleCheckboxChange = (name: string) => {
    setCategoryState((prev) =>
      prev.map((item) =>
        item.title === name ? { ...item, checked: !item.checked } : item,
      ),
    )
  }
  const handleKeyDown = (event: React.KeyboardEvent, name: string) => {
    if (event.key === ' ') {
      event.preventDefault() // Prevent scrolling
      handleCheckboxChange(name)
    }
  }
  return (
    <StyledSelect
      sx={{
        borderRadius: "100px",
        height: "24px",
        border: "none",
        outline: "none",
      }}
      aria-expanded={open ? "true" : undefined}
      labelId={`תיבות סימון מרובות-${label}`}
      multiple
      displayEmpty
      onClose={() => setOpen(false)}
      onOpen={() => setOpen(true)}
      IconComponent={FilterArrowIcon}
      value={categoryState
        .filter((item) => item.checked)
        .map((item) => item.title)}
      renderValue={() => titleHeader}
      MenuProps={{
        MenuListProps: { variant: 'menu', },
        PaperProps: {
          style: {
            minWidth: width(),
            borderRadius: "10px",
            borderTopLeftRadius: 0,
            borderTopRightRadius: 0,
            padding: 0,
            border: "none",
          },
          sx: {
            ".MuiList-root": {
              paddingTop: 0,
              paddingBottom: "28px",
            },
          },
        },
        anchorOrigin: {
          horizontal: "center",
          vertical: "bottom",
        },
        transformOrigin: {
          vertical: isLargeDesktop ? -25 : isDesktop ? -10 : -4,
          horizontal: "center",
        },
      }}
    >
      {categoryState.map(({ checked, title }) => (
        <StyledMenuItem
          value={title}
          selected={checked}
          key={title}
          onClick={() => handleCheckboxChange(title)}
          onKeyDown={(e) => handleKeyDown(e, title)}

        >
          <Checkbox
            icon={<FilterCheckbox checked={checked} />}
            checkedIcon={<FilterCheckbox checked={checked} />}
            checked={checked}
          />
          <ListItemText primary={title} />
        </StyledMenuItem>
      ))}
    </StyledSelect>
  )
}
